import Particle from './Particle';
import { Particles } from '@CS/assets';
import { randomInt } from '@CS/utils/Number';

export default class Image extends Particle {
  protected override readonly useFlip = false;
  private readonly image: HTMLImageElement;

  private halfHeight!: number;
  private halfWidth!: number;

  public constructor(context: CanvasRenderingContext2D) {
    const index = randomInt(1.0, Particles.length) - 1.0;

    super(context);

    this.image = new window.Image();
    this.image.src = Particles[index];

    this.image.onload = () => {
      this.halfHeight = this.image.height * 0.5;
      this.halfWidth = this.image.width * 0.5;

      this.particleHeight = this.image.height;
      this.particleWidth = this.image.width;

      this.setPosition();
      this.setDuration();

      this.running && this.start();
    };
  }

  protected override reset(): void {
    !Image.DropOnce && super.reset();
  }

  public override start(): void {
    !isNaN(this.position.y) && super.start();
  }

  public override draw(): void {
    super.draw();

    this.context.globalAlpha = +this.opacity.toFixed(2.0);
    this.context.drawImage(this.image, -this.halfWidth, -this.halfHeight);

    this.context.restore();
  }
}
